import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";

const AdminPage = lazy(() =>
  import("./admin/AdminPage").then((module) => ({ default: module.AdminPage })),
);
const ContentAdminPage = lazy(() =>
  import("./admin/ContentAdminPage").then((module) => ({ default: module.ContentAdminPage })),
);
const AdminOrdersPage = lazy(() =>
  import("./admin/AdminOrdersPage").then((module) => ({ default: module.AdminOrdersPage })),
);
const AdminProductsPage = lazy(() =>
  import("./admin/AdminProductsPage").then((module) => ({ default: module.AdminProductsPage })),
);
const AdminProductEditPage = lazy(() =>
  import("./admin/AdminProductEditPage").then((module) => ({ default: module.AdminProductEditPage })),
);
const TrackOrderPage = lazy(() =>
  import("./routes/TrackOrderPage").then((module) => ({ default: module.TrackOrderPage })),
);
const AccountPage = lazy(() =>
  import("./routes/AccountPage").then((module) => ({ default: module.AccountPage })),
);
const CartPage = lazy(() =>
  import("./routes/CartPage").then((module) => ({ default: module.CartPage })),
);
const CheckoutCompletePage = lazy(() =>
  import("./routes/CheckoutCompletePage").then((module) => ({
    default: module.CheckoutCompletePage,
  })),
);
const CheckoutPage = lazy(() =>
  import("./routes/CheckoutPage").then((module) => ({ default: module.CheckoutPage })),
);
const CollectionsPage = lazy(() =>
  import("./routes/CollectionsPage").then((module) => ({ default: module.CollectionsPage })),
);
const ProductPage = lazy(() =>
  import("./routes/ProductPage").then((module) => ({ default: module.ProductPage })),
);

export default function App() {
  return (
    <Layout>
      <Suspense fallback={<div className="route-loading">Preparing the atelier…</div>}>
        <Routes>
          <Route index element={<Navigate to="/collections" replace />} />
          <Route path="collections" element={<CollectionsPage />} />
          <Route path="product/:slug" element={<ProductPage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="checkout/complete" element={<CheckoutCompletePage />} />
          <Route path="account" element={<AccountPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="admin/products" element={<AdminProductsPage />} />
          <Route path="admin/products/:id/edit" element={<AdminProductEditPage />} />
          <Route path="admin/content" element={<ContentAdminPage />} />
          <Route path="admin/orders" element={<AdminOrdersPage />} />
          <Route path="track/:token" element={<TrackOrderPage />} />
          <Route path="*" element={<Navigate to="/collections" replace />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}
